var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2550_8743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39568 11.4872C1.75195 11.2726 1.74579 10.9261 2.40801 10.7053L25.946 2.85974C26.5983 2.64269 26.972 3.00772 26.7895 3.64651L20.0636 27.1832C19.8787 27.8356 19.5025 27.8578 19.2263 27.2387L14.7942 17.2647L22.1934 7.39912L12.3278 14.7983L2.39568 11.4872Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2550_8743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5966,
    height: 29.5966,
    fill: "white",
    transform: "translate(-0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e9d2c56ad28a0018d3f5888a0191c63c.svg";
export { ForwardRef as ReactComponent };